import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { setupModal } from "../utils/modal";
import { validateForm } from "./validate-form.js";
import NameInput from "./name-input.js";
import SurnameInput from "./surname-input.js";

const initForm = () => {
  const form = document.querySelector(".form");
  const addButton = form.querySelector(".form__button--add");
  const submitButton = form.querySelector("[type=submit]");
  let namesQuantity = 2;

  flatpickr(".form__input--date", {
    locale: Russian,
    allowInput: true,
    dateFormat: 'd.m.Y'
    // minDate: "today",
    // disableMobile: "true",
  });

  addButton.addEventListener("click", (event) => {
    event.preventDefault();
    if (namesQuantity <= 10) {
      namesQuantity += 1;

      let inputNameElement = new NameInput(namesQuantity);
      let inputSurnameElement = new SurnameInput(namesQuantity);
      let nameInputs = inputNameElement.getElement();
      let surnameInputs = inputSurnameElement.getElement();

      form.insertBefore(nameInputs, addButton);
      form.insertBefore(surnameInputs, addButton);
    }
  });

  validateForm();
};

export { initForm };
